<script setup>
import { router, Head, Link, useForm } from '@inertiajs/vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import JetReportingHeader from '@/Jetstream/ReportingHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import JetWelcomePanel from '@/Jetstream/WelcomePanel.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

//const programme = router.page.props.ziggy.programme;
//const organisation = router.page.props.ziggy.organisation;
const navigationSlugs = JSON.stringify(router.page.props.ziggy.navigationSlugs);
//const urlNamePrefix = organisation ? "gi." : "";

const form = useForm({
    email: '',
    password: ''
});

const submit = () => {

    let slugs = {'subdomain':'reporting'};

    form.transform(data => ({
        ...data,
        subdomain: 'reporting',
    })).post(route('reporting.login', slugs), {
        onFinish: () => form.reset('password'),
    });

};

</script>

<template>

    <AppTheming />

    <JetReportingHeader />

    <Head title="Reporting Dashboard Login" />

    <div id="content-wrapper">

        <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-center w-full pt-5 pb-5">

            <div class="card sos-programme-form-card sos-reporting-form-card p-10 rounded-2xl w-1/2 mt-48">
                    <JetValidationErrors class="mb-4" />

                    <div v-if="status" class="mb-4 font-bold">
                        {{ status }}
                    </div>

                    <form @submit.prevent="submit" class="">
                        <div>
                            <JetLabel for="supervisor_email" :value="$t('reporting.login.email')" />
                            <JetInput
                                id="supervisor_email"
                                v-model="form.email"
                                type="text"
                                class="mt-1 block w-full"
                                required
                                autofocus
                            />

                            <span v-if="$page.props.errors.password" class="text-danger">{{ $page.props.errors.password[0] }}</span>

                        </div>

                        <div class="mt-4">
                            <JetLabel for="name" :value="$t('reporting.login.password')" />
                            <JetInput
                                id="password"
                                v-model="form.password"
                                type="password"
                                class="mt-1 block w-full"
                                required
                            />
                        </div>

                        <div class="flex items-center justify-end mt-4">
                            <Link :href="route('reporting.request-password-reset', { subdomain: 'reporting' })" class="mr-4 text-sm text-gray-600 underline hover:text-gray-900">
                                {{ $t('reporting.login.forgot') }}
                            </Link>
                            <JetButton class="ml-4 whitespace-nowrap" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ $t('reporting.login.log_in') }}
                            </JetButton>
                        </div>
                    </form>

                </div>

        </div>
    </div>

</template>
